// extracted by mini-css-extract-plugin
export default {"grid":"SectionGrid_grid__e57oY"};